<template>
	<div>
		<v-container fluid>
			<v-card class="my-4">
				<v-form
					ref="form"
					@submit.prevent="fetch"
				>
					<v-layout align-center px-4 py-2>
						<v-flex pr-4>
							<v-text-field
								v-model="url"
								label="Parse article URL"
								:clearable="true"
								:loading="loading"
								:rules="[...validate.require, validateURL(url)]"
							/>
						</v-flex>
						<v-flex shrink>
							<v-btn
								:disabled="loading"
								type="submit"
								class="primary"
							>
								fetch
							</v-btn>
						</v-flex>
					</v-layout>
				</v-form>
			</v-card>
			<v-card
				v-if="parserData"
				class="my-4 pa-4"
			>
				<json-view
					:data="parserData"
					rootKey="data"
					:maxDepth="2"
				/>
			</v-card>
			<v-textarea
				v-if="html"
				class="my-4 textarea-code"
				:value="html"
				solo
				auto-grow
				readonly
			/>
			<!-- <pre>
				<code class="language-html" v-html="html"></code>
			</pre> -->
		</v-container>
	</div>
</template>

<script>
import Validation from '@/mixins/Validation';
import { JSONView } from 'vue-json-component';
import axios from '@/util/axios';
import _ from 'lodash';

// import hljs from 'highlight.js/lib/core';
// import 'highlight.js/styles/github.css';
// import html from 'highlight.js/lib/languages/xml';
// hljs.registerLanguage('html', html);

export default {
	components: {
		'json-view': JSONView,
	},
	mixins: [Validation],
	data() {
		return {
			parserData: null,
			html: null,
			url: '',
			loading: false,
		};
	},
	created() {
	},
	computed: {

	},
	methods: {
		fetch() {
			if (!this.$refs.form.validate())
				return;

			this.loading = true;
			this.parserData = null;
			this.html = null;

			axios.post('/super/parse-article', { url: this.url })
				.then((resp) => {
					this.parserData = resp.data;
					this.html = this.parserData.parser.html;
					delete this.parserData.parser.html;
				}).catch((e) => {
					dump('Error parsing article', e);
					this.$notify('error', 'Failed to fetch article.');
				}).finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>

<style lang="scss">
div.json-view-item.root-item {
	> div {
		margin-left: -15px;
		> button {
			display: none;
		}
		> div {
			margin-top: 15px;
			&:first-of-type {
				margin-top: 0;
			}
			> div > button {
				color: red;
			}
		}
	}
}
</style>
<style lang="scss">
.textarea-code textarea {
	font-family: monospace;
	font-size: 0.7em;
}
</style>
